export enum Availability {
    AVAILABLE = "AVAILABLE",
    SOLD_OUT = "SOLD_OUT",
    UNAVAILABLE = "UNAVAILABLE",
    FIXED_TIME = "FIXED_TIME",
    MIXED_STATE = "MIXED_STATE",
}
